export const courtLevels = [
	{
		value: "Court of Appeals",
		label: "Court of Appeals",
	},
	{
		value: "Court of Tax Appeals",
		label: "Court of Tax Appeals",
	},
	{
		value: "Sandiganbayan",
		label: "Sandiganbayan",
	},
	{
		value: "Supreme Court",
		label: "Supreme Court",
	},
	{
		value: "2nd Level Court",
		label: "2nd Level Court",
	},
	{
		value: "1st Level Court",
		label: "1st Level Court",
	},
];
